var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-wrapper"},[_c('Header'),_c('div',{staticClass:"main__content"},[_c('SideBar'),_c('main',{staticClass:"main",class:{ sideBarClosed: _vm.isToggleSideBar }},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }